export default __webpack_public_path__ + "static/media/e6e295069eaef4d5c3957657314705ad.jpg";